import { render, staticRenderFns } from "./PelletsStatistics.vue?vue&type=template&id=6427bb3c&scoped=true"
import script from "./PelletsStatistics.vue?vue&type=script&lang=ts"
export * from "./PelletsStatistics.vue?vue&type=script&lang=ts"
import style0 from "./PelletsStatistics.vue?vue&type=style&index=0&id=6427bb3c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427bb3c",
  null
  
)

export default component.exports